/* eslint-disable radix */
/* eslint-disable no-shadow */
/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react';
import { Formik } from 'formik';
import { toast } from 'react-toastify';
import { useMutation } from '@apollo/client';
import { ADD_EDIT_CONSTANT } from 'utils/constants';
import { CREATE_USER_SUBSCRIPTION_PLAN_PAYMENT } from 'pages/SubscriptionPlans/subscriptionPlanGraphQL';
import { vendorPlanValidationSchema } from 'components/Drawers/components/VendorDetailsDrawer/constant';
import ErrorBoundary from 'components/common/ErrorBoundary';
import VendorSubscriberList from '../VendorSubscribe/components/VendorSubscriberList';
import VendorSubscribeAddOnForm from './components/VendorSubscribeAddOnForm';

const VendorSubscribeAddOn = ({
  drawerToggle,
  type,
  id,
  currency,
  row,
  refetch,
}) => {
  const [calculateAmount, setCalculateAmount] = useState(null);

  const [createUserSubscriptionPayment] = useMutation(
    CREATE_USER_SUBSCRIPTION_PLAN_PAYMENT,
    {
      onCompleted: () => {
        // if (createUserSubscription?.status === 204)
        //   toast.error(createUserSubscription?.message);
        // if (createUserSubscription?.status === 200)
        toast.success("User's Add On created successfully");
        refetch();
        drawerToggle('', ADD_EDIT_CONSTANT.ADD);
      },
      onError: ({ graphQLErrors }) => {
        graphQLErrors.map(({ exception }) => {
          toast.error(exception?.message);
          return exception;
        });
        drawerToggle('', ADD_EDIT_CONSTANT.ADD);
      },
    },
  );

  const handleSubmit = async (values) => {
    try {
      const data = {
        ...values,
        addOnPlanId: parseInt(values.id),
        // mode_of_payment: values?.mode_of_payment?.id,
        // trader: id,
        // activationDate: currentDatePlusDaysToEpoch(),
        // deactivationDate: currentDatePlusDaysToEpoch(values?.duration),
        couponCode: values?.coupon?.code,
        discountAmount: calculateAmount?.couponAmount,
        sgst: calculateAmount?.sGstAmount,
        cgst: calculateAmount?.cGstAmount,
        igst: calculateAmount?.iGstAmount,
        grandTotal: calculateAmount?.grandTotal,
        subTotal: calculateAmount?.subscriptionAmount,
      };
      delete data.coupon;
      delete data.__typename;
      delete data.subscriptionAmount;
      delete data.price;
      delete data.duration;
      delete data.id;
      delete data.subscriptionPlan;
      delete data.discountedAmount;

      // delete data.couponAmount

      await createUserSubscriptionPayment({
        variables: {
          inputDTO: { ...data, userSubscriptionId: row?.id },
          platformType: 'ADMIN',
        },
      });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <VendorSubscriberList vendorId={id} currency={currency} />
      <ErrorBoundary>
        <Formik
          initialValues={{
            subscriptionPlan: '',
            duration: '',
            price: '',
            // mode_of_payment: '',
            coupon: '',
            // trader: id,
            // activationDate: '',
            // deactivationDate: '',
            // isAutoPayEnabled: false,
            // isTrial: false,
            // status: 'ACTIVE',
            // isExpired: false,
            // isDeleted: false,
          }}
          enableReinitialize
          validationSchema={vendorPlanValidationSchema}
          onSubmit={handleSubmit}
          children={(props) => {
            return (
              <VendorSubscribeAddOnForm
                id={id}
                row={row}
                type={type}
                currency={currency}
                {...props}
                drawerToggle={drawerToggle}
                calculateAmount={calculateAmount}
                setCalculateAmount={setCalculateAmount}
                deactivationDate={
                  row?.deactivationDate ? row?.deactivationDate : null
                }
              />
            );
          }}
        />
      </ErrorBoundary>
    </div>
  );
};

export default VendorSubscribeAddOn;
